(function () {
    'use strict';

    angular.module('app.redirectUrls', ['ngRoute']);
})();